import React from 'react';
import PropTypes from 'prop-types';

import { CircularProgress } from '@material-ui/core';
import {
  Container,
  Title,
  Row,
  InfoTitle,
  InfoValue,
  AssinaturaStatus,
  SignatureCanceledCard,
  SignatureText,
  Button,
} from './styles';
import { Centered } from '../../../../components/Layouts/Container/styles';

function AssinaturaInfo({
  status,
  valor,
  dataContratacao,
  onAssinaturaClick,
  isSubmiting = false,
}) {
  const handleButtonClick = () => {
    if (onAssinaturaClick) {
      onAssinaturaClick();
    }
  };

  return (
    <Container>
      <Title>Pacote de Servicos Simples Nacional</Title>
      <Row>
        <InfoTitle>STATUS DA ASSINATURA</InfoTitle>
        <AssinaturaStatus isActive={status === 'Ativa'}>
          {status}
        </AssinaturaStatus>
      </Row>
      <Row>
        <InfoTitle>VALOR DO PLANO</InfoTitle>
        <InfoValue>{valor}</InfoValue>
      </Row>
      <Row>
        <InfoTitle>DATA DE CONTRATAÇÃO</InfoTitle>
        <InfoValue>{dataContratacao}</InfoValue>
      </Row>

      <br />

      {status === 'Suspensa' ? (
        <Centered>
          <SignatureCanceledCard>
            <SignatureText>
              A renovação de sua assinatura foi cancelada, os recursos
              contratados estarão disponíveis até 22/05/2020.
            </SignatureText>
          </SignatureCanceledCard>
          <Button
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
            disabled={isSubmiting}
          >
            {isSubmiting ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              'Ativar assinatura'
            )}
          </Button>
        </Centered>
      ) : status === 'Ativa' ? (
        <Centered>
          <Button
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
            disabled={isSubmiting}
          >
            {isSubmiting ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              'Cancelar assinatura'
            )}
          </Button>
        </Centered>
      ) : (
        <Centered>
          <Button
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
            disabled={isSubmiting}
          >
            {isSubmiting ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              'Contratar uma nova assinatura'
            )}
          </Button>
        </Centered>
      )}
    </Container>
  );
}
// Expirada, Suspensa, Ativa, Cancelada
AssinaturaInfo.propTypes = {
  status: PropTypes.string.isRequired,
  valor: PropTypes.string.isRequired,
  dataContratacao: PropTypes.string.isRequired,
  isSubmiting: PropTypes.bool,
  onAssinaturaClick: PropTypes.func,
};

export default AssinaturaInfo;
